// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_ug-0";